import React, { useCallback, useState } from 'react';
import Cropper from 'react-easy-crop';
import PropTypes from 'prop-types';
import { getCroppedImg } from './getCroppedImg';
import './CropperModal.scss';
import { Reset, Tick } from '../../rootAccess';

const CropperModal = ({ src, onCrop, onCancel, circularCrop = true, viewOnly = false }) => {
   const [crop, setCrop] = useState({ x: 0, y: 0 });
   const [zoom, setZoom] = useState(1);
   const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

   const onCropComplete = useCallback((_, croppedPixels) => {
      setCroppedAreaPixels(croppedPixels);
   }, []);

   const handleConfirm = async () => {
      const blob = await getCroppedImg(src, croppedAreaPixels);
      onCrop(blob);
   };

   const handleReset = () => {
      setCrop({ x: 0, y: 0 });
      setZoom(1);
   };

   return (
      <div className="cropper-modal-overlay">
         <div className="cropper-modal">
            <div className="cropper-header">
               <button className="cropper-close-btn" onClick={onCancel} title="Close">
                  ✕
               </button>
               <span className="cropper-title">{viewOnly ? 'View Photo' : 'Drag and Adjust'}</span>
            </div>

            <div className="cropper-body">
               <Cropper
                  disableAutomaticStylesInjection={viewOnly}
                  image={src}
                  crop={crop}
                  zoom={zoom}
                  aspect={1}
                  cropShape={circularCrop ? 'round' : 'rect'}
                  onCropChange={!viewOnly ? setCrop : () => {}}
                  onZoomChange={!viewOnly ? setZoom : () => {}}
                  onCropComplete={!viewOnly ? onCropComplete : () => {}}
                  showGrid={false}
               />
            </div>
            {!viewOnly && (
               <div className="cropper-footer">
                  <input
                     type="range"
                     min={1}
                     max={3}
                     step={0.1}
                     value={zoom}
                     onChange={e => setZoom(Number(e.target.value))}
                  />

                  <div
                     className="popup-controls"
                     style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap:'10%' }}>
                     <button onClick={handleReset} title="Cancel">
                        <Reset />
                     </button>
                     <button onClick={handleConfirm} title="Confirm">
                        <Tick />
                     </button>
                  </div>
               </div>
            )}
         </div>
      </div>
   );
};

CropperModal.propTypes = {
   src: PropTypes.string.isRequired,
   onCrop: PropTypes.func.isRequired,
   onCancel: PropTypes.func.isRequired,
   circularCrop: PropTypes.bool,
   viewOnly: PropTypes.bool,
};

export default CropperModal;
